/*
 * UploadTestCard — homepage sidebar: send a test (PDF or image) through the
 * three-model pipeline. Logged in, it opens My Tests with the upload form;
 * logged out, it goes to login and comes back to that same form.
 */

import { FC } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { loggedUserInfoStore } from '@/stores';
import { Storage, userCenter } from '@/utils';
import { REDIRECT_PATH_STORAGE_KEY } from '@/common/constants';

const UPLOAD_PATH = '/tests?upload=1';

const UploadTestCard: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'practice_tests' });
  const navigate = useNavigate();
  const { user } = loggedUserInfoStore((_) => _);

  const start = () => {
    if (user.access_token) {
      navigate(UPLOAD_PATH);
      return;
    }
    Storage.set(REDIRECT_PATH_STORAGE_KEY, UPLOAD_PATH);
    navigate(userCenter.getLoginUrl());
  };

  return (
    <Card className="mb-4 upload-test-card">
      <Card.Body>
        <h5 className="card-title">{t('upload_a_test')}</h5>
        <p className="card-text text-body-secondary small">
          {t('upload_card_desc')}
        </p>
        <Button variant="primary" onClick={start}>
          {user.access_token ? t('upload_a_test') : t('log_in_to_upload')}
        </Button>
      </Card.Body>
    </Card>
  );
};

export default UploadTestCard;
